import axiosPrivate from "@services/axiosPrivate";

export const getOutstandingAmount = (doctorId) => {
  return axiosPrivate.post(`/post-payment-outstanding`, {doctorId});
};
